<template>
  <div>
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" class="demo-form-inline" label-width="90px" size="mini">
          <div class="formItemBox">
            <el-form-item label="所在仓库:" prop="organizationId">
              <el-select v-model="searchFrom.organizationId" placeholder="">
                <el-option v-for="val in warehouseList" :label="val.relTenantName" :value="val.relTenantCode" :key="val.relTenantCode"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="货物类型:" prop="productType">
              <el-select  v-model="searchFrom.productType"   placeholder="请选择">
                <el-option v-for="item in productTypes" :label="item.show_name" :value="item.item_no" :key="item.item_no"></el-option>
              </el-select>
            </el-form-item>
               <el-form-item label="货权方:" prop="ownerCustomerName" v-if="tableArr[1]">
                <el-input  placeholder="" v-model="searchFrom.ownerCustomerName"></el-input>
              </el-form-item>
             <el-form-item label="控货方:" prop="primaryCustomerName" v-if="tableArr[0]">
                <el-input  placeholder="" v-model="searchFrom.primaryCustomerName"></el-input>
              </el-form-item>
              <el-form-item label="客户名称:" prop="customerName">
                <el-input  placeholder="" v-model="searchFrom.customerName"></el-input>
              </el-form-item>
              <el-form-item label="入库单号:" prop="instockNo">
                <el-input  placeholder="" v-model="searchFrom.instockNo"></el-input>
              </el-form-item>
               <el-form-item label="产地:" prop="steelMillName">
                <el-input  placeholder="" v-model="searchFrom.steelMillName"></el-input>
              </el-form-item>
               <el-form-item label="规格:" prop="specification">
                <el-input  placeholder="" v-model="searchFrom.specification"></el-input>
              </el-form-item>
               <el-form-item label="材质:" prop="model">
                <el-input  placeholder="" v-model="searchFrom.model"></el-input>
              </el-form-item>
              <el-form-item label="入库车号:" prop="instockPlateNumber" >
                <el-input  placeholder="" v-model="searchFrom.instockPlateNumber"></el-input>
              </el-form-item>
               <el-form-item label="入库司机:" prop="driverName">
                <el-input  placeholder="" v-model="searchFrom.driverName"></el-input>
              </el-form-item>
              <el-form-item label="出厂车号:" prop="outNumber" >
                <el-input  placeholder="" v-model="searchFrom.outNumber"></el-input>
              </el-form-item>
               <el-form-item label="出厂编号:" prop="warehousingNo">
                <el-input  placeholder="" v-model="searchFrom.warehousingNo"></el-input>
              </el-form-item>
               <el-form-item label="入库时间:">
                <el-date-picker
                 v-model="timecheacked"
                 format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
          </div>
        <div class="searchBtnBox">
              <el-form-item>
                  <el-button type="primary" @click="searchFn">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
                </el-form-item>
                 <el-form-item >
                  <el-button type="primary"  @click="exportFn" :disabled="isDisable">导出</el-button>
                </el-form-item>
                 <el-form-item>
                  <p class="margin0">总件数：<span class="red">{{tongji.totalNumber}}</span>件</p>
                </el-form-item>
                <el-form-item>
                  <p class="margin0">总重量：<span class="red">{{tongji.totalAllWeight}}</span>吨</p>
                </el-form-item>
            </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border v-if="tableArr.length>0">
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
          <el-table-column prop="instockNo"  width="220" :formatter="emptyFn" label="入库单号"></el-table-column>
       <el-table-column prop="instockDate"  min-width="200" :formatter="dateTimeFormat" label="入库时间"></el-table-column>
       <el-table-column prop="ownerCustomerName"  min-width="200" v-if="tableArr[1]" :formatter="emptyFn" label="货权方"></el-table-column>
      <el-table-column prop="primaryCustomerName"  min-width="200" v-if="tableArr[0]" :formatter="emptyFn" label="控货方"></el-table-column>
         <el-table-column prop="customerName"  min-width="200" :formatter="emptyFn" label="客户名称"></el-table-column>
         <el-table-column prop="factoryWeight"  width="150"  label="出厂过磅净重(吨)"></el-table-column>
        <el-table-column prop="productTypeName"  min-width="150" :formatter="emptyFn" label="货物类型"></el-table-column>
        <el-table-column prop="steelMillName"  width="150" :formatter="emptyFn" label="产地"></el-table-column>
          <el-table-column prop="specification"  min-width="150" :formatter="emptyFn" label="规格"></el-table-column>
        <el-table-column prop="model"  min-width="120" :formatter="emptyFn" label="材质"></el-table-column>
        <!-- <el-table-column prop="root"  width="150" :formatter="emptyFn" label="单件支数"></el-table-column>
        <el-table-column prop="length"  min-width="150" :formatter="emptyFn" label="长度(m)"></el-table-column> -->
        <el-table-column prop="number"  min-width="120" :formatter="emptyFn" label="入库件数"></el-table-column>
        <el-table-column prop="allWeight"  width="150" label="入库重量(吨)"></el-table-column>
        <el-table-column prop="weight"  min-width="150"  label="入库理重(吨)"></el-table-column>
        <el-table-column prop="weighingWeight"  width="150"  label="入库磅重(吨)"></el-table-column>
        <el-table-column prop="instockPlateNumber"    min-width="120" :formatter="emptyFn" label="入库车号"></el-table-column>
        <el-table-column prop="driverName"  min-width="120" :formatter="emptyFn" label="入库司机"></el-table-column>
        <el-table-column prop="telephone"  min-width="150" :formatter="emptyFn" label="司机电话"></el-table-column>
        <el-table-column prop="organizationName"  width="150" :formatter="emptyFn" label="所在仓库"></el-table-column>
        <el-table-column prop="outNumber"  min-width="150" :formatter="emptyFn" label="出厂车号"></el-table-column>
        <el-table-column prop="warehousingNo"  width="150" :formatter="emptyFn" label="出厂编号"></el-table-column>
        <el-table-column prop="plateNumber"  min-width="120" :formatter="emptyFn" label="车船号"></el-table-column>
         <el-table-column prop="shipForecastNo"  min-width="170" :formatter="emptyFn" label="预报编号"></el-table-column>
          <el-table-column prop="inExternalNo"  min-width="120" :formatter="emptyFn" label="入库外部单号"></el-table-column>
         <el-table-column prop="ext1"  min-width="120" :formatter="emptyFn" label="备注"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
 </div>
</template>

<script>
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import { getInStockThreadList, getInStockThreadWN, selectCommonDictionary } from '@/api/soc-stock-cosco'
import { exportExcel } from '@/utils/fileDown.js'
import { getAttribute } from '@/utils/getButton'
export default {
  props: {
    productTypes: {
      type: Array,
      required: true
    },
    warehouseList: {
      type: Array,
      required: true
    }

  },
  data () {
    return {
      tableArr: [],
      timecheacked: '',
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      dialogVisible: false,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      loading: 'false',
      goodTypes: [],
      tongji: {},
      isDisable: false,
      oneCustomerTaxId: localStorage.getItem('tenantTaxpayerNumber')
    }
  },
  created () {
    this.searchFrom.oneOrTwoCustomerTaxId = this.oneCustomerTaxId
    this.tableArr = getAttribute('ARRoneCustomerName,ARRownerCustomerName')
    if (this.warehouseList.length > 0) {
      this.$set(this.searchFrom, 'organizationId', this.warehouseList[0].relTenantCode)
    }
    this.getList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 210) + 'px'
  },
  methods: {
    // 导出
    exportFn () {
      let falg = this.tableArr[0]
      let form = { ...this.searchFrom }
      // form.list = []
      // if (!falg) {
      //   form.list.push('oneCustomerName')
      // }
      // if (!this.tableArr[1]) {
      //   form.list.push('ownerCustomerName')
      // }
      delete form.pageNo
      delete form.pageSize
      form.primaryCustomerNameFlag = falg
      form.ownerCustomerNameFlag = this.tableArr[1]
      exportExcel(
        this.global.wmsCenter + '/wmsApi/exportInStockThreadList',
        form,
        '入库记录'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    searchFn () {
      if (this.timecheacked) {
        this.searchFrom.instockDateStart = this.timecheacked[0]
        this.searchFrom.instockDateStartEnd = this.timecheacked[1]
      } else {
        this.searchFrom.instockDateStart = null
        this.searchFrom.instockDateStartEnd = null
      }

      this.getList()
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList () {
      this.loading = true

      getInStockThreadList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
      getInStockThreadWN(this.searchFrom).then(res => {
        this.tongji = res
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList()
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        oneOrTwoCustomerTaxId: this.oneCustomerTaxId,
        organizationId: this.warehouseList[0].relTenantCode
      }
      this.timecheacked = null
    },

    closeDialog () {
      this.addFrom = {}
      this.$refs.table.clearSelection()
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
  width: 400px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
</style>
